<template>
  <div class="opple-ability-ui-com-slider">
    <div class="opple-ability-ui-com-slider_inner">
      <el-slider
        v-model="numValue"
        :min="minVal"
        :max="maxVal"
        :disabled="item.Readonly"
        class="opple-ability-ui-com-slider_track"
        :format-tooltip="formatTooltip"
      />
      <span class="opple-ability-ui-com-slider_value">{{ displayValue }}</span>
      <span
        v-if="item.ParaUnit"
        class="opple-ability-ui-com-slider_unit"
      >{{ item.ParaUnit }}</span>
    </div>
  </div>
</template>

<script>
import { NEIGHBOR_GROUP } from '@/utils/enums';

function isHexString(item) {
  return item.KeyId === 224;
}

export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
  },
  data() {
    return {
      numValue: 0
    };
  },
  computed: {
    minVal() {
      return this.item.Min != null ? Number(this.item.Min) : 0;
    },
    maxVal() {
      return this.item.Max != null ? Number(this.item.Max) : 100;
    },
    displayValue() {
      const p = this.item.UI && this.item.UI.Precision;
      if (p && typeof p === 'string' && p.includes('.')) {
        const decimals = (p.split('.')[1] || '').length;
        return Number(this.numValue).toFixed(decimals);
      }
      return this.numValue;
    }
  },
  mounted() {
    this.initValue();
  },
  methods: {
    formatTooltip(val) {
      const p = this.item.UI && this.item.UI.Precision;
      if (p && typeof p === 'string' && p.includes('.')) {
        const decimals = (p.split('.')[1] || '').length;
        return Number(val).toFixed(decimals);
      }
      return String(val);
    },
    initValue() {
      const { DefaultValue } = this.item;
      if (DefaultValue !== undefined && DefaultValue !== null && DefaultValue !== '') {
        if (isHexString(this.item)) {
          this.numValue = +DefaultValue - parseInt(NEIGHBOR_GROUP, 16);
        } else {
          const n = Number(DefaultValue);
          this.numValue = Number.isFinite(n) ? n : this.minVal;
        }
      } else {
        this.numValue = this.minVal;
      }
    },
    getData() {
      const { item } = this;
      const hasUIPrecision = !!(item.UI && item.UI.Precision);

      if (isHexString(item)) {
        return {
          Key: item.KeyId,
          Values: [`${(parseInt(NEIGHBOR_GROUP, 16) + this.numValue)}`]
        };
      }

      if (hasUIPrecision) {
        const precision = item.UI.Precision.split('.')[1].split('').length * 10;
        return {
          Key: item.KeyId,
          Values: `${this.numValue * precision}`.split(',')
        };
      }

      return {
        Key: item.KeyId,
        Values: `${this.numValue}`.split(',')
      };
    }
  }
};
</script>

<style lang="scss">
.opple-ability-ui-form {
  .opple-ability-ui-com-slider {
    width: 100%;

    &_inner {
      display: flex;
      align-items: center;
      gap: 12px;
    }

    &_track {
      flex: 1;
      min-width: 0;
    }

    &_value {
      flex-shrink: 0;
      min-width: 2em;
      font-size: 14px;
      font-variant-numeric: tabular-nums;
      color: #303133;
      text-align: right;
    }

    &_unit {
      flex-shrink: 0;
      font-size: 12px;
      color: #606266;
    }
  }
}
</style>
